import { render, staticRenderFns } from "./MenulinguaPro.vue?vue&type=template&id=7c935ca5&scoped=true&"
import script from "./MenulinguaPro.vue?vue&type=script&lang=js&"
export * from "./MenulinguaPro.vue?vue&type=script&lang=js&"
import style0 from "./MenulinguaPro.vue?vue&type=style&index=0&id=7c935ca5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c935ca5",
  null
  
)

export default component.exports